import React, { useEffect, useState, useMemo } from 'react';
import { useAuth } from '../../contexts/auth';
import { createStore } from 'devextreme-aspnet-data';
import DataGrid, { Column } from 'devextreme-react/data-grid';

export default function CompanyCashFlowTable(props) {

    const { user } = useAuth();

    const dataInizio = props.dataInizio
    const dataFine = props.dataFine
    const intermediario = props.intermediario
    const commessa = props.commessa

    //const projectId = props.projectId;

    const [rawData, setRawData] = useState([]);

    const [projectValue, setProjectValue] = useState({});
    const [realValue, setRealValue] = useState({});
    const [transactions, setTransactions] = useState({});
    const [analyticsData, setAnalyticsData] = useState([]);

    const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa';
    const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Contabilita';

      //var cashFlowUrl = "CompanyCashFlowByProject";
    var cashFlowUrl = "CompanyCashFlowForecast";
    if (props.type ==='Actual') 
        //cashFlowUrl ="CompanyCashFlowActualByProject";
        cashFlowUrl ="CompanyCashFlowActual";
    else if (props.type ==='Original') 
        //cashFlowUrl ="CompanyCashFlowOriginalByProject";
        cashFlowUrl ="CompanyCashFlowOriginal";
       

    const filterPayload = { 
        intermediario: intermediario,
        fromDate: dataInizio,
        toDate: dataFine,
        commessa: commessa
    };
        
    const remoteDataSource = createStore({
        key: 'id',
        //loadUrl: serviceUrl + '/CompanyCashFlowByProject',
        loadUrl: serviceUrl + '/' + cashFlowUrl,
        onBeforeSend: (method, ajaxOptions) => {
            if (method == "load" ) {
                //initParametri();             
                var payload = ajaxOptions.data;
                payload.values = JSON.stringify(filterPayload);
                ajaxOptions.data = payload;          
                //console.log(ajaxOptions.data);
                //console.log('IntermediarioId:' + intermediario);
            }        
            //ajaxOptions.xhrFields = { withCredentials: true };
            ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}  
        },    
    });

    const remoteDataSource2 = createStore({
        key: 'id',
        //loadUrl: serviceUrl2 + '/FindCompanyAnalitica',
        loadUrl: serviceUrl2 + '/CompanyAnaliticaActual',
       
        onBeforeSend: (method, ajaxOptions) => {
            if (method === "load" ) {           
               var payload = ajaxOptions.data;
               payload.values = JSON.stringify(filterPayload);
               ajaxOptions.data = payload;          
            }  
            ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};
        }  
    });

    const remoteDataSource3 = createStore({
        key: 'id',
        loadUrl: serviceUrl + '/GetCompanyTransactionsActual',
       
        onBeforeSend: (method, ajaxOptions) => {
            if (method === "load" ) {           
               var payload = ajaxOptions.data;
               payload.values = JSON.stringify(filterPayload);
               ajaxOptions.data = payload;          
            }  
            ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};
        }  
    });

    const remoteDataSource4 = createStore({
        key: 'id',
        loadUrl: serviceUrl + '/GetCompanyOriginalValues',
       
        onBeforeSend: (method, ajaxOptions) => {
            if (method === "load" ) {           
               var payload = ajaxOptions.data;
               payload.values = JSON.stringify(filterPayload);
               ajaxOptions.data = payload;          
            }  
            ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};
        }  
    });

    const remoteDataSource5 = createStore({
        key: 'id',
        loadUrl: serviceUrl + '/GetCompanyRealValues',
       
        onBeforeSend: (method, ajaxOptions) => {
            if (method === "load" ) {           
               var payload = ajaxOptions.data;
               payload.values = JSON.stringify(filterPayload);
               ajaxOptions.data = payload;          
            }  
            ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};
        }  
    });

    //CARICAMENTO DATI
    useEffect(() => {
        remoteDataSource.load().then(data => {
            //console.log("DATA DAL SERVER:", data);
            setRawData(data);
        });

         remoteDataSource2.load().then(data => {
            setAnalyticsData(data);
        });

        remoteDataSource3.load().then(data => {
            setTransactions(data);
        });

        remoteDataSource4.load().then(data => {
            setProjectValue(data);
        });

        remoteDataSource5.load().then(data => {
            setRealValue(data);
        });

    }, [commessa]);

    //PIVOT
    const buildTableData = (data) => {
        if (!Array.isArray(data)) return [];

        const entrateRow = { tipo: "Entrate" };
        const usciteRow = { tipo: "Uscite" };
        const cassaRow = { tipo: "Cassa" };

        data.forEach(item => {
            const mese = item.meseAnno; 

            entrateRow[mese] = item.entrate;
            usciteRow[mese] = item.uscite;
            cassaRow[mese] = item.cassa;
        });

        return [entrateRow, usciteRow, cassaRow];
    };

    const tableData = useMemo(() => buildTableData(rawData), [rawData]);

   //mesi dinamici
    const months = useMemo(() => {
        return [...new Set(
            rawData
                .filter(item => item?.annoMese && item?.meseAnno)
                .sort((a, b) => a.annoMese.localeCompare(b.annoMese))
                .map(item => item.meseAnno)
        )];
    }, [rawData]);

    // Dati analitici con riga di totale
    const analyticsDataWithTotal = useMemo(() => {
        if (!Array.isArray(analyticsData) || analyticsData.length === 0) {
            return [];
        }
        
        const totalDare = analyticsData.reduce((sum, item) => sum + (item.dare || 0), 0);
        const totalAvere = analyticsData.reduce((sum, item) => sum + (item.avere || 0), 0);
        
        return [
            ...analyticsData,
            {
                categoria: "Totale",
                dare: totalDare,
                avere: totalAvere,
                isTotal: true
            }
        ];
    }, [analyticsData]);
    
    // useEffect(() => {

    //     const fetchData = async () => {
    
    //     const requestOptions = {
    //         headers: {
    //             Authorization: `Bearer ${user.token}`
    //         }
    //     };

    //     //const prjId = props.data.key;

    //     // const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa';
    //     // var newUrl1 =  newServiceUrl1 + "/GetCompanyProjectValues/" + commessa;

    //     // const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa';
    //     // var newUrl2 =  newServiceUrl2 + "/GetCompanyRealValues/" + commessa;

    //     // const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa';
    //     // var newUrl3 =  newServiceUrl3 + "/GetCompanyTransactions/" + commessa;
    
    //       try {
    
    //         // const response1 = await fetch(newUrl1,requestOptions);
    //         // const json1 = await response1.json();
    //         // console.log(json1);
    //         // setProjectValue(json1);

    //         // const response2 = await fetch(newUrl2,requestOptions);
    //         // const json2 = await response2.json();
    //         // console.log(json2);
    //         // setRealValue(json2);

    //         // const response3 = await fetch(newUrl3,requestOptions);
    //         // const json3 = await response3.json();
    //         // console.log(json3);
    //         // setTransactions(json3);

    
    //       } catch (error) {
    //         console.log("error", error);
    //       }
    //     };
    
    //     fetchData();
    //   }, []);

const values =
    (props.type === 'Forecast' || props.type === 'Actual')
        ? realValue
        : projectValue;

console.log("TIPO: " + values);

const totaleCosti = values?.[0]?.totaleCosti || 0;
const totaleRicavi = values?.[0]?.totaleRicavi || 0;

const pagato = transactions?.[0]?.pagato || 0;
const incassato = transactions?.[0]?.incassato || 0;

const margine = totaleRicavi - totaleCosti;

const marginePerc =
    totaleRicavi !== 0
        ? (margine / totaleRicavi) * 100
        : 0;

const summaryData = [
    {
        voce: "Costi",
        valore: totaleCosti
    },
    {
        voce: "Ricavi",
        valore: totaleRicavi
    },
    {
        voce: "Margine",
        valore: margine
    },
    {
        voce: "Margine %",
        valore: marginePerc
    }
];

const actualSummaryData = [
    {
        voce: "Costi",
        valore: totaleCosti,
        pagamenti: pagato,
        incassi: null,
        percentuale:
            totaleCosti !== 0
                ? (pagato / totaleCosti) * 100
                : 0
    },
    {
        voce: "Ricavi",
        valore: totaleRicavi,
        pagamenti: null,
        incassi: incassato,
        percentuale:
            totaleRicavi !== 0
                ? (incassato / totaleRicavi) * 100
                : 0
    },
    {
        voce: "Margine",
        valore: margine,
        pagamenti: null,
        incassi: null,
        percentuale: null
    },
    {
        voce: "Margine %",
        valore: marginePerc,
        pagamenti: null,
        incassi: null,
        percentuale: null
    }
];

  return (
 <div>

    <DataGrid dataSource={tableData} showBorders={true}
        onCellPrepared={(e) => {
            if (e.rowType === "data") {
            
                if (typeof e.value === "number" && e.value < 0) {
                    e.cellElement.style.color = "#d32f2f";
                }

                if (e.data?.tipo === "Cassa") {
                    e.cellElement.style.fontWeight = "600";
                    e.cellElement.style.backgroundColor = "#f5f5f5";
                }
            }
        }}
    >
        <Column dataField="tipo" caption="" />

        {months.map(m => (
            <Column
                key={m}
                dataField={m}
                caption={m}
                customizeText={(cellInfo) => {

                    if (
                        cellInfo.value === null ||
                        cellInfo.value === undefined
                    ) {
                        return "";
                    }

                    return cellInfo.value.toLocaleString('de-DE', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                }}
            />
        ))}
 
    </DataGrid>

{(props.type === 'Original' || props.type === 'Forecast') && (
    <div style={{ marginTop: '20px', width: '350px' }}>

    <DataGrid
        dataSource={summaryData}
        showBorders={true}
        columnAutoWidth={true}
        showColumnHeaders={true}
        onCellPrepared={(e) => {

            if (e.rowType === "data") {

                // Numeri negativi in rosso
                if (
                    e.column.dataField === "valore" &&
                    typeof e.value === "number" &&
                    e.value < 0
                ) {
                    e.cellElement.style.color = "#d32f2f";
                }

                // Evidenzia riga Margine
                if (e.data?.voce === "Margine %") {
                    e.cellElement.style.fontWeight = "600";
                    e.cellElement.style.backgroundColor = "#f5f5f5";
                }
            }
        }}
    >

        <Column
            dataField="voce"
            caption="Voce"
            width={180}
        />

        <Column
            dataField="valore"
            caption="Importo"
            alignment="right"
            customizeText={(cellInfo) => {

                if (cellInfo.data?.voce === "Margine %") {
                    return `${cellInfo.value.toFixed(2)}%`;
                }

                return cellInfo.value.toLocaleString('de-DE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            }}
        />

    </DataGrid>
    </div>
)}

{props.type === 'Actual' && (
    <div style={{ marginTop: '20px', display: 'flex', gap: '20px', width: '100%' }}>
        
        {/* Tabella Summary - Sinistra */}
        <div style={{ flex: 1 }}>
            <h3 style={{ marginTop: 0, marginBottom: '10px' }}>Riepilogo</h3>
            <DataGrid
                dataSource={actualSummaryData}
                showBorders={true}
                columnAutoWidth={true}
                showColumnHeaders={true}
                onCellPrepared={(e) => {

                    if (e.rowType === "data") {

                        // Numeri negativi rossi
                        if (
                            typeof e.value === "number" &&
                            e.value < 0
                        ) {
                            e.cellElement.style.color = "#d32f2f";
                        }

                        // Evidenzia Margine %
                        if (
                            e.data?.voce === "Margine %"
                        ) {
                            e.cellElement.style.fontWeight = "600";
                            e.cellElement.style.backgroundColor = "#f5f5f5";
                        }
                    }
                }}
            >

                <Column
                    dataField="voce"
                    caption="Voce"
                    width={180}
                />

                <Column
                    dataField="valore"
                    caption="Importo"
                    alignment="right"
                    customizeText={(cellInfo) => {

                        if (cellInfo.data?.voce === "Margine %") {
                            return `${cellInfo.value.toFixed(2)}%`;
                        }

                        if (
                            cellInfo.value === null ||
                            cellInfo.value === undefined
                        ) {
                            return "";
                        }

                        return cellInfo.value.toLocaleString('de-DE', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        });
                    }}
                />

                <Column
                    dataField="pagamenti"
                    caption="Pagamenti"
                    alignment="right"
                    customizeText={(cellInfo) => {

                        if (
                            cellInfo.value === null ||
                            cellInfo.value === undefined
                        ) {
                            return "";
                        }

                        return cellInfo.value.toLocaleString('de-DE', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        });
                    }}
                />

                <Column
                    dataField="incassi"
                    caption="Incassi"
                    alignment="right"
                    customizeText={(cellInfo) => {

                        if (
                            cellInfo.value === null ||
                            cellInfo.value === undefined
                        ) {
                            return "";
                        }

                        return cellInfo.value.toLocaleString('de-DE', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        });
                    }}
                />

                <Column
                    dataField="percentuale"
                    caption="%"
                    alignment="right"
                    customizeText={(cellInfo) => {

                        if (
                            cellInfo.value === null ||
                            cellInfo.value === undefined
                        ) {
                            return "";
                        }

                        return `${cellInfo.value.toFixed(2)}%`;
                    }}
                />

            </DataGrid>
        </div>

        {/* Tabella Analitiche - Destra */}
        <div style={{ flex: 1 }}>
            <h3 style={{ marginTop: 0, marginBottom: '10px' }}>Analitica</h3>
            <DataGrid
                dataSource={analyticsDataWithTotal}
                showBorders={true}
                columnAutoWidth={true}
                showColumnHeaders={true}
                onCellPrepared={(e) => {

                    if (e.rowType === "data") {

                        // Numeri negativi rossi per Dare e Avere
                        if (
                            (e.column.dataField === "dare" || e.column.dataField === "avere") &&
                            typeof e.value === "number" &&
                            e.value < 0
                        ) {
                            e.cellElement.style.color = "#d32f2f";
                        }

                        // Evidenzia riga Totale
                        if (e.data?.isTotal) {
                            e.cellElement.style.fontWeight = "600";
                            e.cellElement.style.backgroundColor = "#f5f5f5";
                        }
                    }
                }}
            >

                <Column
                    dataField="categoria"
                    caption="Categoria"
                    width={200}
                />

                <Column
                    dataField="dare"
                    caption="Dare"
                    alignment="right"
                    customizeText={(cellInfo) => {

                        if (
                            cellInfo.value === null ||
                            cellInfo.value === undefined
                        ) {
                            return "";
                        }

                        return cellInfo.value.toLocaleString('de-DE', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        });
                    }}
                />

                <Column
                    dataField="avere"
                    caption="Avere"
                    alignment="right"
                    customizeText={(cellInfo) => {

                        if (
                            cellInfo.value === null ||
                            cellInfo.value === undefined
                        ) {
                            return "";
                        }

                        return cellInfo.value.toLocaleString('de-DE', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        });
                    }}
                />

            </DataGrid>
        </div>

    </div>
)}

  </div>
);


}